import { Badge } from "@qw/ui";
import type { FC } from "react";
import type { ProductHistoricalInsights } from "../historical-insights.types";
import { formatCurrency } from "../insights-utils";

interface Props {
  pricing: ProductHistoricalInsights["pricing"];
}

const RateBlock: FC<{
  label: string;
  rate: ProductHistoricalInsights["pricing"]["carrierRate"];
}> = ({ label, rate }) => {
  if (!rate) {
    return null;
  }
  return (
    <div className="rounded-md border p-3 space-y-1">
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium">{label}</span>
        {rate.trend && <Badge variant="secondary">{rate.trend}</Badge>}
      </div>
      <div className="text-xs text-muted-foreground">
        {formatCurrency(rate.rateLow)} – {formatCurrency(rate.rateMid)} – {formatCurrency(rate.rateHigh)}
        {rate.rateUnit && <span> / {rate.rateUnit}</span>}
      </div>
      <div className="text-xs text-muted-foreground">Sample size: {rate.sampleSize}</div>
    </div>
  );
};

export const InsightsPricingSection: FC<Props> = ({ pricing }) => {
  if (!pricing.carrierRate && !pricing.marketRate) {
    return null;
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Pricing</h3>
      <div className="grid grid-cols-2 gap-3">
        <RateBlock label="Carrier Rate" rate={pricing.carrierRate} />
        <RateBlock label="Market Rate" rate={pricing.marketRate} />
      </div>
    </div>
  );
};
